import { useEffect } from 'react'
import { fetchLlmChatSession } from '@/shared/hooks/api/llmChat'
import {
  selectSessionState,
  useLlmChatStore,
} from '../store/llmChatStore'

export function useLlmChatSessionLoader(sessionId: string | undefined) {
  const sessionState = useLlmChatStore((state) =>
    selectSessionState(state, sessionId)
  )

  useEffect(() => {
    if (!sessionId) {
      return
    }
    const store = useLlmChatStore.getState()
    store.setActiveSessionId(sessionId)
    const existing = store.sessions.get(sessionId)
    if (existing?.loadStatus === 'loaded' || existing?.loadStatus === 'loading') {
      return
    }
    store.setSessionLoading(sessionId)
    void fetchLlmChatSession(sessionId)
      .then((data) => {
        useLlmChatStore.getState().initializeSessionFromServer(sessionId, data)
      })
      .catch((error: unknown) => {
        const message =
          error instanceof Error ? error.message : 'Failed to load session'
        useLlmChatStore.getState().setSessionLoadError(sessionId, message)
      })
  }, [sessionId])

  return {
    sessionState,
    isLoading: sessionState?.loadStatus === 'loading' || sessionState === undefined,
    isError: sessionState?.loadStatus === 'error',
    loadError: sessionState?.loadError,
    isLoaded: sessionState?.loadStatus === 'loaded',
  }
}
